// extracted by mini-css-extract-plugin
export default {"contact_container":"ContactSection_contact_container__N1eTS","mail":"ContactSection_mail__jzAtR"};